import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { stockInConstant } from "../constants/constants";


class StockInStore extends EventEmitter {



    handleAction(action) {
        switch (action.type) {
            case stockInConstant.STOCKIN_CREATED: {
                this.emit(stockInConstant.STOCKIN_CREATED, `stockIn created successfully.`);
                break;
            }
            case stockInConstant.STOCKIN_CREATION_FAILED: {
                this.emit(stockInConstant.STOCKIN_CREATION_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const stockInStore = new StockInStore();
dispatcher.register(stockInStore.handleAction.bind(stockInStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
export default stockInStore;


// WEBPACK FOOTER //
// ./src/jsx/store/stockin-store.jsx